// Shared round-name translator used both in LeagueDetails and PredictionModal.
// Logic mirrors what was originally in LeagueDetails.js.

export const FOOTBALL_ROUND_PATTERNS = [
	{ re: /^Regular Season\s*-\s*(\d+)$/i, key: 'regular_season' },
	{ re: /^1st Phase\s*-\s*(\d+)$/i, key: 'first_phase' },
	{ re: /^Championship Round\s*-\s*(\d+)$/i, key: 'championship_round' },
	{ re: /^Championship Group\s*-\s*(\d+)$/i, key: 'championship_group' },
	{ re: /^Relegation Group\s*-\s*(\d+)$/i, key: 'relegation_group' },
	{ re: /^Group Stage\s*-\s*(\d+)$/i, key: 'group_stage' },
	{ re: /^League Stage\s*-\s*(\d+)$/i, key: 'league_stage' },
	{ re: /^Club Friendlies\s+(\d+)$/i, key: 'club_friendlies_n' },
];

const slugifyRound = (name) =>
	String(name).toLowerCase().replace(/[^a-z0-9 ]/g, '').replace(/\s+/g, '_');

export const slugifyLeague = (name) => {
	if (!name) return '';
	return name.toLowerCase().replace(/[^a-z0-9 ]/g, '').replace(/\s+/g, '_');
};

export const translateLeague = (name, t) => {
	if (!name) return '';
	return t(`league_names.${slugifyLeague(name)}`, { defaultValue: name });
};

export const translateTeamName = (name, t) => {
	if (!name) return '';
	return t(`teams.${name}`, { defaultValue: name });
};

export const isNumericRound = (round) =>
	round !== null && round !== undefined && round !== '' && !isNaN(Number(round)) && /^-?\d+$/.test(String(round).trim());

export const translateRound = (round, tournamentName, t) => {
	if (round === null || round === undefined || round === '') return '';

	if (isNumericRound(round)) {
		return t([
			`rounds.${tournamentName}.${round}`,
			`rounds.default.${round}`,
			`rounds.generic`,
		], {
			round,
			defaultValue: `${round}. kolo`,
		});
	}

	const str = String(round).trim();

	for (const { re, key } of FOOTBALL_ROUND_PATTERNS) {
		const m = str.match(re);
		if (m) {
			return t(`rounds.football.patterns.${key}`, { n: m[1], defaultValue: str });
		}
	}

	return t(`rounds.football.exact.${slugifyRound(str)}`, { defaultValue: str });
};
